import styled from '@emotion/styled';
// import { Link } from 'react-router-dom';

// --- Typography ---

export const BlogHeading = styled.h2<{ level?: 1 | 2 | 3 | 4 | 5 | 6 }>`
  font-family: 'Space Grotesk', sans-serif;
  color: #111827;
  font-weight: 700;
  line-height: 1.3;
  margin-top: 48px;
  margin-bottom: 24px;
  scroll-margin-top: 100px; /* For sticky header offset */

  ${props => {
    switch (props.level) {
      case 1: return 'font-size: 48px; @media (max-width: 768px) { font-size: 36px; }';
      case 2: return 'font-size: 32px; @media (max-width: 768px) { font-size: 28px; }';
      case 3: return 'font-size: 24px;';
      case 4: return 'font-size: 20px;';
      default: return 'font-size: 18px;';
    }
  }}
`;

export const BlogText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  line-height: 1.8;
  color: #374151;
  margin-bottom: 24px;
`;

export const BlogLink = styled.a`
  color: #7c3aed;
  text-decoration: underline;
  font-weight: 500;
  transition: color 0.2s ease;
  cursor: pointer;

  &:hover {
    color: #6d28d9;
  }
`;

// --- Layout Components ---

export const BlogSection = styled.section`
  margin-bottom: 60px;
`;

export const BlogGrid = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 2}, 1fr);
  gap: 16px; /* Reduced from 24px */
  margin: 32px 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// --- Special Components ---

export const BlogQuote = styled.blockquote`
  border-left: 4px solid #e5e7eb; /* Neutral gray */
  padding: 24px 32px;
  margin: 40px 0;
  background: transparent; /* Removed background */
  
  p {
    font-family: 'Space Grotesk', sans-serif;
    font-size: 20px;
    font-weight: 500;
    font-style: italic;
    color: #111827;
    margin: 0;
  }

  cite {
    display: block;
    margin-top: 16px;
    font-size: 14px;
    color: #6b7280;
    font-style: normal;
    font-weight: 600;
  }
`;

export const BlogCallout = styled.div<{ type?: 'info' | 'warning' | 'success' }>`
  padding: 24px;
  border-radius: 8px;
  margin: 0 0;
  background: #ffffff; /* White background */
  border: 1px solid ${props => {
    switch (props.type) {
      case 'warning': return '#f59e0b'; /* Amber-500 */
      case 'success': return '#10b981'; /* Emerald-500 */
      default: return '#3b82f6'; /* Blue-500 */
    }
  }};

  h4 {
    color: ${props => {
    switch (props.type) {
      case 'warning': return '#b45309';
      case 'success': return '#047857';
      default: return '#1d4ed8';
    }
  }};
    margin: 0 0 8px 0;
    font-family: 'Space Grotesk', sans-serif;
    font-weight: 700;
  }

  p {
    color: #374151;
    margin: 0;
    font-size: 16px;
  }
`;

export const BlogList = styled.ul`
  margin-bottom: 24px;
  padding-left: 24px;

  li {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    line-height: 1.8;
    color: #374151;
    margin-bottom: 12px;
    position: relative;
    padding-left: 8px;

    &::marker {
      color: #9ca3af; /* Neutral marker */
    }
  }
`;

export const BlogImage = styled.figure`
  margin: 40px 0;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    /* Removed box-shadow */
  }

  figcaption {
    text-align: center;
    font-size: 14px;
    color: #6b7280;
    margin-top: 12px;
    font-style: italic;
  }
`;

// --- Table Components ---

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 40px 0;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const BlogTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Inter', sans-serif;
  font-size: 16px;

  thead {
    background: #f9fafb;
    border-bottom: 2px solid #e5e7eb;
  }

  th {
    padding: 16px 24px;
    text-align: left;
    font-weight: 600;
    color: #111827;
    font-family: 'Space Grotesk', sans-serif;
    white-space: nowrap;
  }

  td {
    padding: 16px 24px;
    color: #374151;
    border-bottom: 1px solid #e5e7eb;
    vertical-align: top;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: #f9fafb;
  }
`;
